import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ENV_VARS } from "../../config/env";
import iframeStore from "../../pages/IframeNew/iframe-store";
import { isConsolePath, isMigrationIframe } from "../../utils/migrationIframe";

/**
 * When the user is on the full platform (not in migration iframe, not in iframe store)
 * and navigates to a console route (dashboard, account, models, etc.), redirect
 * the top window to platform-frontend /console so the console is shown in the iframe there.
 */
export function RedirectConsoleToPlatformFrontend() {
	const location = useLocation();

	useEffect(() => {
		if (typeof window === "undefined") return;
		if (iframeStore.isIframe()) return;
		if (isMigrationIframe()) return;

		if (!isConsolePath(location.pathname)) return;

		const base = ENV_VARS.VITE_NEW_PLATFORM_URL;
		if (!base || typeof base !== "string") return;

		const normalizedPath = location.pathname.startsWith("/") ? location.pathname : `/${location.pathname}`;
		const search = location.search ? location.search : "";
		const target = `${base.replace(/\/$/, "")}/console${normalizedPath}${search}`;
		window.location.replace(target);
	}, [location.pathname, location.search]);

	return null;
}
